(() => {
  'use strict';
  const money = cents => `${Math.round(cents / 100).toLocaleString('tr-TR')} TL`;
  const normalize = value => String(value || '').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i').replace(/\s+/g, ' ').trim();

  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-kilif-data]').textContent);
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const form = $('.stk-kilif-form');
    const submit = $('.stk-kilif-submit');
    const error = $('.stk-kilif-error');
    const panel = $('.stk-kilif-model-panel');
    const trigger = $('[data-open-model]');
    const search = $('[data-model-search]');
    const desktop = window.matchMedia('(min-width:990px)');
    let selected = data.variants.find(v => String(v.id) === String(data.selected)) || data.variants[0];
    let view = 0;
    let busy = false;

    function pictures() {
      return ['duz', 'aci', 'elde', '4'].map((angle, index) => {
        const scene = (index === 3 ? data.gallery : data.scenes).find(image => image.alt === `${selected.model}|${angle}`);
        const white = data.gallery.find(image => image.alt === `${selected.model}|${index + 1}`);
        const fallback = (index === 0 && selected.image ? { src: selected.image, small: selected.imageSmall } : null) || data.media[index] || data.media[0];
        return { image: scene || white || fallback, thumb: white || scene || fallback, close: index === 3 || (!scene && !!white) };
      });
    }
    // Galeri hızı: seçili modelin 4 görünümü arka planda önceden indirilir (sahne <img> ile aynı srcset/sizes,
    // tarayıcı aynı boyutu seçip önbellekten verir); kaydırınca yalnız adres değişir, bekleme olmaz.
    const STAGE_SIZES = '(min-width: 990px) 55vw, calc(100vw - 32px)';
    const sized = (url, width) => String(url).replace(/([?&])width=\d+/, `$1width=${width}`);
    const warm = new Map();
    function preloadViews() {
      pictures().forEach(item => {
        const pic = item.image;
        if (!pic || warm.has(pic.src)) return;
        const img = new Image();
        img.decoding = 'async';
        img.sizes = STAGE_SIZES;
        if (pic.small) img.srcset = `${pic.small} 720w, ${pic.src} 1200w`;
        img.src = pic.small || pic.src;
        warm.set(pic.src, img);
      });
    }
    function schedulePreload() {
      const run = () => (window.requestIdleCallback ? requestIdleCallback(preloadViews, { timeout: 1200 }) : setTimeout(preloadViews, 300));
      const first = $('[data-stage-image]');
      if (first && !first.complete) first.addEventListener('load', run, { once: true }); else run();
    }
    function paintGallery() {
      const images = pictures();
      if (!images[view].image) view = 0;
      const chosen = images[view];
      const stage = $('.stk-kilif-stage');
      let image = $('[data-stage-image]');
      if (!image && chosen.image) {
        image = document.createElement('img');
        image.dataset.stageImage = '';
        image.width = image.height = 1200;
        image.sizes = STAGE_SIZES;
        stage.prepend(image);
      }
      if (image) {
        image.hidden = !chosen.image;
        if (chosen.image) {
          image.src = chosen.image.small || chosen.image.src;
          image.srcset = chosen.image.small ? `${chosen.image.small} 720w, ${chosen.image.src} 1200w` : '';
          image.alt = `${data.title} · ${selected.model} · ${['Düz', '3/4', 'Elde', 'Yakın'][view]}`;
        }
      }
      $('[data-no-image]').hidden = !!chosen.image;
      stage.classList.toggle('is-close', chosen.close);
      $$('[data-view]').forEach((tab, index) => {
        tab.setAttribute('aria-pressed', String(index === view));
        tab.disabled = !images[index].image;
        const thumb = tab.querySelector('img');
        thumb.hidden = !images[index].thumb;
        if (images[index].thumb) thumb.src = sized(images[index].thumb.small || images[index].thumb.src, 176);
      });
      if (typeof paintDots === 'function' && dots) paintDots();
      schedulePreload();
    }
    function setImage(target, src, alt) {
      if (!target) return;
      target.hidden = !src;
      if (src) target.src = src;
      if (alt !== undefined) target.alt = alt;
    }
    const stageBox = $('.stk-kilif-stage');
    const dots = document.createElement('div');
    dots.className = 'stk-kilif-dots';
    dots.setAttribute('aria-hidden', 'true');
    stageBox.append(dots);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function paintDots() {
      const images = pictures();
      dots.replaceChildren(...images.filter(item => item.image).map((item, index, list) => {
        const dot = document.createElement('i');
        if (images.indexOf(item) === view) dot.className = 'is-on';
        return dot;
      }));
    }
    function stepView(step) {
      const images = pictures();
      const available = images.map((item, index) => (item.image ? index : -1)).filter(index => index >= 0);
      if (available.length < 2) return false;
      const position = Math.max(0, available.indexOf(view));
      view = available[(position + step + available.length) % available.length];
      paintGallery();
      return true;
    }
    let swipe = null;
    stageBox.addEventListener('touchstart', event => {
      if (event.touches.length !== 1) { swipe = null; return; }
      swipe = { x: event.touches[0].clientX, y: event.touches[0].clientY, dx: 0, locked: null };
    }, { passive: true });
    stageBox.addEventListener('touchmove', event => {
      if (!swipe) return;
      const touch = event.touches[0];
      swipe.dx = touch.clientX - swipe.x;
      const dy = touch.clientY - swipe.y;
      if (swipe.locked === null && (Math.abs(swipe.dx) > 8 || Math.abs(dy) > 8)) swipe.locked = Math.abs(swipe.dx) > Math.abs(dy);
      const image = $('[data-stage-image]');
      if (swipe.locked && image) image.style.transform = `translateX(${swipe.dx * 0.5}px)`;
    }, { passive: true });
    stageBox.addEventListener('touchend', () => {
      if (!swipe) return;
      const { dx, locked } = swipe;
      swipe = null;
      const image = $('[data-stage-image]');
      if (image) image.style.transform = '';
      if (!locked || Math.abs(dx) < 40) return;
      const step = dx < 0 ? 1 : -1;
      if (stepView(step) && image && !reduceMotion.matches && image.animate) {
        image.animate([{ transform: `translateX(${step * 48}px)`, opacity: 0.2 }, { transform: 'none', opacity: 1 }], { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
    });
    stageBox.addEventListener('touchcancel', () => { swipe = null; const image = $('[data-stage-image]'); if (image) image.style.transform = ''; });
    function paint() {
      form.elements.id.disabled = false;
      form.elements.id.value = selected.id;
      $('[data-price]').textContent = money(selected.price);
      $('[data-type-price]').textContent = money(selected.price);
      $('[data-model-name]').textContent = selected.model;
      $$('[data-selected-model]').forEach(node => { node.textContent = selected.model; });
      setImage($('[data-type-image]'), selected.img, `${data.title} · ${selected.model}`);
      setImage($('[data-sticky-image]'), selected.img);
      $('[data-sticky-price]').textContent = money(selected.price);
      $('[data-sticky-submit]').disabled = busy || !selected.available;
      $('[data-sticky-submit]').textContent = busy ? 'Ekleniyor…' : selected.available ? 'Sepete ekle' : 'Tükendi';
      $('[data-current-type-link]').href = `?variant=${selected.id}`;
      $('[data-stock]').textContent = selected.available ? 'Stokta' : 'Tükendi';
      $('[data-device]').src = selected.device;
      submit.disabled = busy || !selected.available;
      submit.textContent = busy ? 'Ekleniyor…' : selected.available ? `Sepete ekle · ${money(selected.price)}` : 'Tükendi';
      $$('[data-model-id]').forEach(button => button.setAttribute('aria-pressed', String(String(selected.id) === button.dataset.modelId)));
      const siblingLink = $('[data-sibling-link]');
      if (siblingLink && data.sibling) {
        const match = data.sibling.variants.find(v => normalize(v.model) === normalize(selected.model));
        const url = new URL(data.sibling.url, location.origin);
        if (match) url.searchParams.set('variant', match.id);
        siblingLink.href = url.pathname + url.search;
        if (match) $('[data-sibling-price]').textContent = money(match.price);
        setImage($('[data-sibling-image]'), match ? match.img : data.sibling.variants[0]?.img, `${data.title} · ${selected.model}`);
      }
      const customDesign = $('[data-custom-design]');
      if (customDesign) {
        const url = new URL('/products/kendi-tasarim-kilif', location.origin);
        url.searchParams.set('tur', customDesign.dataset.kind);
        url.searchParams.set('model', selected.model);
        customDesign.href = url.pathname + url.search;
      }
      paintGallery();
      const close = data.gallery.find(image => image.alt === `${selected.model}|4`)
        || pictures()[0].image;
      const closeImage = $('[data-close-image]');
      setImage(closeImage, close && (close.small || close.src), `${data.title} · ${selected.model} · Yakın`);
      closeImage.srcset = close && close.small ? `${close.small} 720w, ${close.src} 1200w` : '';
    }
    function updateURL() {
      const url = new URL(location.href);
      url.searchParams.set('variant', selected.id);
      history.replaceState(history.state, '', url);
    }
    function closePanel() {
      panel.close();
      trigger.setAttribute('aria-expanded', 'false');
    }
    function filterModels() {
      const query = normalize(search.value);
      let count = 0;
      $$('[data-model-group]').forEach(group => {
        let visible = 0;
        group.querySelectorAll('[data-model-text]').forEach(row => {
          row.hidden = !normalize(row.dataset.modelText).includes(query);
          if (!row.hidden) visible++;
        });
        group.hidden = visible === 0;
        count += visible;
      });
      $('[data-no-results]').hidden = count > 0;
    }
    root.addEventListener('click', event => {
      const tab = event.target.closest('[data-view]');
      if (tab) { view = Number(tab.dataset.view); paintGallery(); }
      const model = event.target.closest('[data-model-id]');
      if (model) {
        const variant = data.variants.find(v => String(v.id) === model.dataset.modelId);
        if (!variant) return;
        selected = variant;
        try { localStorage.setItem('stk_kilif_model', selected.model); } catch (_) { /* Storage can be disabled. */ }
        updateURL();
        error.hidden = true;
        paint();
        if (panel.open) closePanel();
      }
      if (event.target.closest('[data-open-model]')) {
        search.value = '';
        filterModels();
        if (panel.open) { closePanel(); return; }
        if (desktop.matches) panel.show(); else panel.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        search.focus({ preventScroll: true });
      }
      if (event.target.closest('[data-close-model]')) closePanel();
      if (event.target.closest('[data-sticky-submit]')) form.requestSubmit(submit);
    });
    search.addEventListener('input', filterModels);
    panel.addEventListener('close', () => { trigger.setAttribute('aria-expanded', 'false'); trigger.focus({ preventScroll: true }); });
    panel.addEventListener('click', event => {
      if (event.target !== panel) return;
      const rect = panel.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closePanel();
    });
    // Abort document listeners when a Shopify editor replaces this section.
    const lifecycle = new AbortController();
    document.addEventListener('click', event => {
      if (desktop.matches && panel.open && !panel.contains(event.target) && !trigger.contains(event.target)) closePanel();
    }, { signal: lifecycle.signal });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && panel.open) closePanel();
    }, { signal: lifecycle.signal });
    let timerInterval;
    let stickyObserver;
    let sizeObserver;
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { closePanel(); lifecycle.abort(); clearInterval(timerInterval); stickyObserver?.disconnect(); sizeObserver?.disconnect(); }
    }, { signal: lifecycle.signal });
    desktop.addEventListener('change', () => { if (panel.open) closePanel(); }, { signal: lifecycle.signal });

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !selected.available) return;
      busy = true;
      error.hidden = true;
      paint();
      const id = selected.id;
      const drawer = document.querySelector('cart-drawer');
      try {
        if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(submit);
        const sections = drawer && typeof drawer.getSectionsToRender === 'function'
          ? drawer.getSectionsToRender().map(section => section.id)
          : ['cart-drawer', 'cart-icon-bubble', 'cart-free-delivery'];
        const response = await fetch(`${data.root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }], sections, sections_url: location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status || result.errors) throw new Error(typeof result.description === 'string' ? result.description : 'Ürün eklenemedi. Lütfen tekrar dene.');
        // Once added, a drawer rendering failure must never invite an accidental second add.
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'stk-kilif-urun', productVariantId: id, cartData: result });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (drawer && typeof drawer.renderContents === 'function' && result.sections && result.sections['cart-drawer']) {
            result.id = id;
            drawer.renderContents(result);
          } else location.assign(`${data.root}cart`);
        } catch (_) { location.assign(`${data.root}cart`); }
      } catch (err) {
        error.textContent = err instanceof TypeError ? 'Sepete ekleme doğrulanamadı. Sepetini kontrol edip tekrar dene.' : err.message;
        error.hidden = false;
      } finally { busy = false; paint(); }
    });

    const w = $('[data-kilif-timer]');
    if (w) {
    var D = [
      [0, '🌙 GECE FIRSATI', '3 Al 2 Öde · en ucuzu bedava, sepette otomatik'],
      [2, '⏳ 3 AL 2 ÖDE SÜRÜYOR', '3 kaplama ya da sticker seç, en ucuzu bedava'],
      [4, '🌜 GECE FIRSATI SÜRÜYOR', '3 Al 2 Öde — Uyumadan Yakala!'],
      [6, '☕ GÜNE FIRSATLA BAŞLA', '3 Al 2 Öde · sepette otomatik uygulanır'],
      [8, '🔥 HERKES SEPETİNİ DOLDURUYOR', '3 Al 2 Öde — Geç Kalma!'],
      [11, '⚡ 3 AL 2 ÖDE ŞİMDİ AKTİF', '3 seç, en ucuzu bedava'],
      [14, '🚨 ÜÇÜNCÜSÜ BEDAVA', '3 Al 2 Öde — sepette otomatik'],
      [17, '⏰ SAYILI SAATLER KALDI', '3 Al 2 Öde · en ucuzu bedava'],
      [20, '🌆 AKŞAM FIRSATI', '3 Al 2 Öde — kombinini tamamla'],
      [22, '🌙 SON 2 SAAT', '3 Al 2 Öde — Gün Bitmeden Kap!']
    ];
    var hh = w.querySelector('[data-tm-hh]'), mm = w.querySelector('[data-tm-mm]'), ss = w.querySelector('[data-tm-ss]'), bar = w.querySelector('[data-tm-bar]'), eh = w.querySelector('[data-tm-h]'), es = w.querySelector('[data-tm-s]'), last = -1;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function trNow() { var n = new Date(); return new Date(n.getTime() + (n.getTimezoneOffset() + 180) * 60000); }
    function win() {
      var tr = trNow(), now = Date.now(), list = [];
      function at(df, h) { var d = new Date(tr.getTime()); d.setDate(d.getDate() + df); d.setHours(h, 0, 0, 0); return d.getTime() - (new Date().getTimezoneOffset() + 180) * 60000; }
      for (var df = -1; df <= 1; df++) for (var i = 0; i < D.length; i++) list.push({ t: at(df, D[i][0]), i: i });
      list.sort(function (a, b) { return a.t - b.t; });
      for (var j = 1; j < list.length; j++) if (list[j].t > now) return { a: list[j - 1].t, b: list[j].t, i: list[j - 1].i };
      return { a: now, b: now + 3600000, i: 0 };
    }
    function tick() {
      var p = win(), left = p.b - Date.now(), tot = p.b - p.a, sn = Math.max(0, Math.floor(left / 1000)), pct = tot > 0 ? Math.min(100, Math.max(0, (1 - left / tot) * 100)) : 0;
      hh.textContent = pad(Math.floor(sn / 3600)); mm.textContent = pad(Math.floor((sn % 3600) / 60)); ss.textContent = pad(sn % 60);
      if (bar) bar.style.width = pct.toFixed(2) + '%';
      if (p.i !== last) { last = p.i; eh.textContent = D[p.i][1]; es.textContent = D[p.i][2]; }
    }
    tick();
    timerInterval = setInterval(tick, 1000);
    }
    function deliveryDate() {
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const part = type => Number(parts.find(p => p.type === type).value);
      const today = new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
      function after(days) {
        const date = new Date(today);
        while (days > 0) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) days--;
        }
        return date;
      }
      const start = after(4), end = after(5);
      const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
      const label = date => `${date.getUTCDate()} ${months[date.getUTCMonth()]}`;
      const range = start.getUTCMonth() === end.getUTCMonth() && start.getUTCFullYear() === end.getUTCFullYear()
        ? `${start.getUTCDate()}–${label(end)}` : `${label(start)} – ${label(end)}`;
      $('[data-delivery]').textContent = `Tahmini teslimat: ${range}`;
    }
    deliveryDate();
    const stickyCart = $('[data-sticky-cart]');
    let mainVisible = true;
    function updateStickyCart() {
      stickyCart.hidden = desktop.matches || mainVisible;
    }
    if ('IntersectionObserver' in window) {
      stickyObserver = new IntersectionObserver(entries => {
        mainVisible = entries[0].isIntersecting;
        updateStickyCart();
      });
      stickyObserver.observe(submit);
      desktop.addEventListener('change', updateStickyCart, { signal: lifecycle.signal });
    }
    function updateInfoSticky() {
      const info = $('.stk-kilif-info');
      const gallery = $('.stk-kilif-gallery');
      info.classList.toggle('is-sticky', desktop.matches && info.offsetHeight < gallery.offsetHeight);
    }
    if ('ResizeObserver' in window) {
      sizeObserver = new ResizeObserver(updateInfoSticky);
      sizeObserver.observe($('.stk-kilif-info'));
      sizeObserver.observe($('.stk-kilif-gallery'));
    }
    desktop.addEventListener('change', updateInfoSticky, { signal: lifecycle.signal });
    updateInfoSticky();

    const variantParam = new URL(location.href).searchParams.get('variant');
    if (variantParam) selected = data.variants.find(v => String(v.id) === variantParam) || selected;
    else {
      try {
        const remembered = localStorage.getItem('stk_kilif_model');
        const match = data.variants.find(v => normalize(v.model) === normalize(remembered));
        if (match) { selected = match; updateURL(); }
      } catch (_) { /* Keep Shopify's selected variant. */ }
    }
    paint();
  }
  const initialize = scope => scope.querySelectorAll('[data-kilif-product]').forEach(init);
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
